import { render } from "./InvitationFuneralListPage.vue?vue&type=template&id=0e58f696&lang=true"
import script from "./InvitationFuneralListPage.vue?vue&type=script&lang=js"
export * from "./InvitationFuneralListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__